import { useRef, useEffect } from 'react';
import {
  dbui_v1_TestAccessRequest,
  dbuiV1TestAccessMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useTestAccess = () => {
  const { workspace } = useWorkspace();
  const abortControllerRef = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (data: dbui_v1_TestAccessRequest) => {
      abortControllerRef.current?.abort();
      const controller = new AbortController();
      abortControllerRef.current = controller;

      const response = await dbuiV1TestAccessMutation({
        ...defaultOptions(),
      }).mutationFn!({
        body: data,
        path: { workspace },
        signal: controller.signal,
      });

      return response;
    },
  });

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return mutation;
};
